if (!customElements.get('product-454')) {
  customElements.define('product-454', class extends HTMLElement {
    connectedCallback() {
      this.dataset.enhanced = 'true';
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('submit', this.handleSubmit.bind(this));
      this.addEventListener('change', event => {if(event.target.name === 'selling_plan') this.updatePlan(event.target);});
      this.productLocation = location.pathname + location.search;
      this.onPopState = () => {
        const current = location.pathname + location.search;
        if (current === this.productLocation) return;
        this.productLocation = current;
        this.updateProduct(new URL(location.href), null, false);
      };
      window.addEventListener('popstate', this.onPopState);
      this.observePurchase();
    }
    disconnectedCallback() {
      this.request?.abort();
      this.observer?.disconnect();
      window.removeEventListener('popstate', this.onPopState);
    }
    handleClick(event) {
      const option = event.target.closest('[data-option-link]');
      if (option && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        const url = new URL(option.href);
        const current = new URL(location.href);
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        }
        this.updateProduct(url, option.id, true);
        return;
      }
      const quantityButton = event.target.closest('[data-quantity]');
      if (quantityButton) {
        const input = quantityButton.closest('.f454-quantity').querySelector('input');
        quantityButton.dataset.quantity === 'plus' ? input.stepUp() : input.stepDown();
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
      const thumbnail = event.target.closest('[data-thumbnail]');
      if (thumbnail) {
        const gallery = thumbnail.closest('[data-gallery]');
        const image = gallery.querySelector('.f454-hero-image');
        image.sizes = thumbnail.dataset.sizes;
        image.srcset = thumbnail.dataset.srcset;
        image.width = Number(thumbnail.dataset.width);
        image.height = Number(thumbnail.dataset.height);
        image.src = thumbnail.dataset.image;
        gallery.dataset.zoomImage = thumbnail.dataset.zoomImage;
        image.alt = thumbnail.dataset.alt;
        gallery.querySelectorAll('[data-thumbnail]').forEach(button => {
          const selected = button === thumbnail;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected);
        });
      }
      if (event.target.closest('[data-zoom]')) {
        const gallery = event.target.closest('[data-gallery]');
        const original = gallery.querySelector('.f454-hero-image');
        const dialog = gallery.querySelector('dialog');
        const enlarged = dialog.querySelector('img');
        enlarged.src = gallery.dataset.zoomImage || original.currentSrc || original.src;
        enlarged.alt = original.alt;
        dialog.showModal();
      }
      if (event.target.closest('[data-close-zoom]')) event.target.closest('dialog').close();
      const localAnchor = event.target.closest('a[href^="#"]');
      if (localAnchor && document.documentElement.hasAttribute('data-454-preview')) {
        event.preventDefault();
        const target = this.querySelector(localAnchor.getAttribute('href'));
        if (target?.tagName === 'DETAILS') target.open = true;
        target?.scrollIntoView({behavior:'smooth', block:'start'});
      }
      const guide = event.target.closest('[data-size-guide]');
      if (guide) {
        const details = this.querySelector(guide.getAttribute('href'));
        if (details) details.open = true;
      }
    }
    async updateProduct(url, focusId, updateHistory) {
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      this.setAttribute('aria-busy', 'true');
      const quantity = this.querySelector('[name="quantity"]')?.value;
      const openDetails = [...this.querySelectorAll('details[open][id]')].map(item => item.id);
      const fetchUrl = new URL(url);
      fetchUrl.hash = ''; 
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(fetchUrl, {signal:request.signal});
        if (!response.ok) throw new Error('section');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('[data-product-content]');
        if (!next || (document.documentElement.lang === 'nl' && !next.dataset.productId)) throw new Error('section');
        this.querySelector('[data-product-content]').replaceWith(next);
        const input = this.querySelector('[name="quantity"]');
        if (input && quantity) {
          input.value = quantity;
          if (!input.checkValidity()) input.value = input.min || 1;
        }
        openDetails.forEach(id => {const details = this.querySelector(`#${CSS.escape(id)}`); if(details) details.open = true;});
        if (updateHistory && !document.documentElement.hasAttribute('data-454-preview')) {
          if (next.dataset.variantId) {
            url.searchParams.delete('option_values');
            url.searchParams.set('variant', next.dataset.variantId);
          }
          history.pushState({}, '', url);
        }
        this.productLocation = location.pathname + location.search;
        if (focusId) this.querySelector(`#${CSS.escape(focusId)}`)?.focus({preventScroll:true});
        this.observePurchase();
        this.dispatchEvent(new CustomEvent('454:variant-change', {bubbles:true, detail:{variantId:next.dataset.variantId}}));
      } catch (error) {
        if (error.name !== 'AbortError') location.assign(url);
      } finally {
        if (this.request === request) this.removeAttribute('aria-busy');
      }
    }
    updatePlan(select) {
      const option = select.selectedOptions[0];
      const price = this.querySelector('[data-current-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      const stickyPrice = this.querySelector('.f454-sticky strong');
      if (stickyPrice && option?.dataset.price) stickyPrice.textContent = option.dataset.price;
      const unitPrice = this.querySelector('[data-unit-money]');
      if (unitPrice && option?.dataset.unitPrice) unitPrice.textContent = option.dataset.unitPrice;
      const compare = this.querySelector('.f454-prices s');
      if (compare) compare.hidden = !!select.value;
      const note = this.querySelector('[data-plan-note]');
      if (note) note.hidden = !select.value;
    }
    observePurchase() {
      this.observer?.disconnect();
      const button = this.querySelector('.f454-add');
      const sticky = this.querySelector('[data-sticky]');
      if (!button || !sticky || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold:0.1});
      this.observer.observe(button);
    }
    async handleSubmit(event) {
      if (!event.target.matches('.f454-form')) return;
      const form = event.target;
      if (!form.reportValidity()) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button.disabled) return;
      const status = form.querySelector('[data-form-status]');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const data = new FormData(form);
      if (cart?.getSectionsToRender) {
        data.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        data.append('sections_url', location.pathname);
        cart.setActiveElement?.(button);
      }
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      status.textContent = '';
      status.classList.remove('is-error');
      let added = false;
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {method:'POST', headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}, body:data});
        const result = await response.json();
        if (!response.ok || result.status) {
          status.textContent = result.description || result.message || this.dataset.error;
          status.classList.add('is-error');
          return;
        }
        added = true;
        status.textContent = this.dataset.added;
        const showCart = () => {
          if (cart?.renderContents && result.sections && Object.values(result.sections).every(Boolean)) {
            cart.classList.remove('is-empty');
            cart.renderContents(result);
          } else {
            location.assign(window.routes?.cart_url || '/cart');
          }
        };
        if (await window.F454BundleUpgrade?.afterAdd({variantId:Number(data.get('id')),quantity:Number(data.get('quantity'))||1,sellingPlan:data.get('selling_plan'),onDismiss:showCart})) return;
        showCart();
      } catch (error) {
        if (added) location.assign(window.routes?.cart_url || '/cart');
        else {
          status.textContent = this.dataset.error;
          status.classList.add('is-error');
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}



